export const ROUTE = {
  ALL: '*',
  CUSTOMER_SUPPORT_INFORMATION: '/customer-support-information',
  FORGOT_PASSWORD: '/forgot-password',
  HOME: '/',
  LOGIN: '/login',
  ORGANIZATION_UNITS: '/organization-units',
  PERMISSIONS: '/permissions',
  PROFILE: '/profile',
  RESET_PASSWORD: '/reset-password',
  ROLES: '/roles',
  SERVICE_TYPES: '/service-types',
  USERS: '/users',
  USER_GROUPS: '/user-groups',
  VERIFY_FORGOT_PASSWORD: '/verify-forgot-password',
  FREQUENTLY_ASKED_QUESTION: '/frequently-asked-questions',
  SERVICE_INSTRUCTIONS: '/service-instructions',
  WORKING_SCHEDULES: '/working-schedules',
  SHIFTS: '/shifts',
  REASONS: '/reasons',
  VIP_CUSTOMERS: '/vip-customers',
  INTERNAL_CHAT: '/internal-chat',
  CUSTOMER_LOOKUP: '/customer-lookup',
  NOTE: '/note',
  TICKET_SAMPLES: '/ticket-samples',
  TICKET_CANCEL_REASONS: '/ticket-cancel-reasons',
  INTERNAL_ANNOUNCEMENTS: '/internal-announcements',
  INTERNAL_ANNOUNCEMENTS_DELETED: '/internal-announcements/deleted',
  RATING_SYSTEM: '/rating-system',
  AGENT_MAPS: '/agent-maps',
  CALL_CENTER_SYSTEM: '/call-center-system',
  API_SHARING_PARTNERS: '/api-sharing-partners',
  ORGANIZATION_UNIT_TICKET_DEFAULT_ASSIGNS: '/organization-unit-ticket-default-assigns',
  REQUEST_FORM: '/request-form',
  FANPAGE_CONNECTIONS: '/fanpage-connections',
  ACCESS_DTV_MANAGEMENT: '/access-dtv-management',
  TRACKING_TICKETS_PROCESSING: '/tracking-tickets-processing',
  COLLABORATION_REQUEST: '/collaboration-request',
  MOVE_CENTER: 'transfer-center',
  TRANSFER_CUSTOMER_SERVICE_TEAM: 'transfer-customer-service-team',
  MOVE_TECHNICAL_DEPARTMENT: 'transfer-technical-department',
  INCORRECT_MEASUREMENT_POINT_ADDRESS: 'incorrect-measurement-point-address',
  FOLLOWING_REQUEST: 'following-request',
  COLLECT_PAYMENT: 'collect-payment',
  CUSTOMER_SEARCH: '/customer-search',
  CONFIRM_REFLECTION_REQUEST: '/confirm-reflection-request',
  VIP_CUSTOMERS_GROUP: '/vip-customer-group',
  CALL_HISTORY: 'call-history',
  SMS: '/sms',
  CREATE_TICKET_FROM_EXCEL: '/create-ticket-from-excel',

  TOOLS: 'tools',
  SYNC_CUSTOMER: 'sync-customer',

  CHAT_MANAGEMENT: '/chat-management',
  AI_AGENT_MANAGEMENT: '/ai-agent-center',
  SETTING_AI_AGENT: '/setting-ai-agent'
};
